import { Button, Modal } from "@ai-teach/ui-web";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  variant?: "danger" | "warning" | "info";
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  variant = "info",
}: ConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  const buttonVariantMap = {
    danger: "danger" as const,
    warning: "primary" as const,
    info: "primary" as const,
  };

  const buttonVariant = buttonVariantMap[variant];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="p-6">
        <p className="text-gray-700 dark:text-secondary-200 mb-6">{message}</p>

        <div className="flex justify-end gap-3">
          <Button onClick={onClose} disabled={isLoading} variant="secondary" size="sm">
            {cancelText}
          </Button>
          <Button onClick={handleConfirm} disabled={isLoading} variant={buttonVariant} size="sm">
            {isLoading ? "Processing..." : confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
